export const SESSION_STORAGE_KEY = "chatairag_chat_session_id";
export const CHAT_TOPIC_STORAGE_KEY = "chatairag_chat_topic";
export const THEME_STORAGE_KEY = "dark";
